import { addMonths } from 'date-fns';

const validMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Converts company's fiscalYearEndMonth to taxFilingDeadline
 * @param taxYear
 * @param fiscalYearEndDate
 * @param taxType
 */
export const companyFyeToTaxDeadline = (
  taxYear = 2021,
  fiscalYearEndDate: string | null = 'December',
  taxType: string,
) => {
  // default to December
  let fiscalYearEndMonth = 'December';
  if (fiscalYearEndDate && validMonthNames.includes(fiscalYearEndDate)) {
    fiscalYearEndMonth = fiscalYearEndDate;
  }

  // convert month string to date
  const fiscalEndDate = new Date(
    Date.parse(`${fiscalYearEndMonth} 15, ${taxYear}`),
  );

  // if any month besides December, increment year
  if (fiscalYearEndMonth !== 'December') {
    fiscalEndDate.setFullYear(fiscalEndDate.getFullYear() + 1);
  }

  // if tax type is 1120, personal, or 990t then deadline is 4 months after fiscal year-end
  // else, keep the 3-month deadline
  let deadlineMonths = 3;

  if (taxType && ['1120', 'personal', '990t'].includes(taxType)) {
    deadlineMonths = 4;
  }

  return addMonths(fiscalEndDate, deadlineMonths);
};
